import React, { createContext, useCallback, useContext, useState } from 'react';
import ConfirmModal from '../components/Common/ConfirmModal';

const ConfirmContext = createContext(() => Promise.resolve(false));

const DEFAULT_STATE = {
  open: false,
  title: 'Are you sure?',
  description: '',
  confirmLabel: 'Confirm',
  cancelLabel: 'Cancel',
  danger: false,
  resolver: null,
};

export const ConfirmProvider = ({ children }) => {
  const [state, setState] = useState(DEFAULT_STATE);

  const confirm = useCallback((opts = {}) => {
    return new Promise((resolve) => {
      setState({
        open: true,
        title: opts.title || 'Are you sure?',
        description: opts.description || '',
        confirmLabel: opts.confirmLabel || 'Confirm',
        cancelLabel: opts.cancelLabel || 'Cancel',
        danger: !!opts.danger,
        resolver: resolve,
      });
    });
  }, []);

  const close = (result) => {
    if (state.resolver) state.resolver(result);
    setState((prev) => ({ ...prev, open: false, resolver: null }));
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <ConfirmModal
        open={state.open}
        title={state.title}
        description={state.description}
        confirmLabel={state.confirmLabel}
        cancelLabel={state.cancelLabel}
        danger={state.danger}
        onConfirm={() => close(true)}
        onCancel={() => close(false)}
      />
    </ConfirmContext.Provider>
  );
};

export const useConfirm = () => useContext(ConfirmContext);
